import React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { useInitializePrices } from '@hooks';
import { ReactFCV } from '@types';

import { DEFAULT_CURRENCY_SETUP, DEFAULT_SEPARATOR_SETUP } from './constants';
import { IPriceModel, ISeparatorModel } from './model';
import { StyledCheckoutPriceWrapper, StyledPrice, StyledSlash } from './styled';

export interface ICheckoutPriceProps extends IBasicStyledProps {
  price: number;
  /**
   * Contains properties for currency visually rendered first
   */
  firstCurrency?: IPriceModel;
  /**
   * Contains properties for currency visually rendered second
   */
  secondCurrency?: IPriceModel;
  dualPriceEnabled?: boolean;
  isColumnLayout?: boolean;
  separator?: ISeparatorModel;
  isHighLighted?: boolean;
  isOldPrice?: boolean;
  isActive?: boolean;
  showSeparatorInColumn?: boolean;
}

export const CheckoutPrice: ReactFCV<ICheckoutPriceProps> = ({
  price,
  firstCurrency = DEFAULT_CURRENCY_SETUP,
  secondCurrency = DEFAULT_CURRENCY_SETUP,
  dualPriceEnabled = true,
  isColumnLayout = false,
  separator = DEFAULT_SEPARATOR_SETUP,
  isHighLighted = false,
  isOldPrice = false,
  isActive = true,
  showSeparatorInColumn = false,
  ...rest
}) => {
  const { firstPrice, secondPrice } = useInitializePrices(price, dualPriceEnabled);
  return (
    <StyledCheckoutPriceWrapper data-testid={'priceWrapper'} isColumnLayout={isColumnLayout} {...rest}>
      {firstPrice && dualPriceEnabled && (
        <>
          <StyledPrice
            data-testid={'firstPrice'}
            price={firstPrice.price}
            currencySymbol={firstPrice.currencySymbol}
            currencyFormat={firstPrice.currencyFormat}
            priceSize={firstCurrency.priceSize}
            currencySize={firstCurrency.currencySize}
            bold={firstCurrency.bold}
            isHighLighted={isHighLighted}
            isOldPrice={isOldPrice}
            isActive={isActive}
            showSeparatorInColumn={showSeparatorInColumn}
          />

          <StyledSlash data-testid={'separator'} {...separator} visible={!isColumnLayout} />
        </>
      )}

      <StyledPrice
        data-testid={'secondPrice'}
        price={secondPrice.price}
        currencySymbol={secondPrice.currencySymbol}
        currencyFormat={secondPrice.currencyFormat}
        priceSize={secondCurrency.priceSize}
        currencySize={secondCurrency.currencySize}
        bold={secondCurrency.bold}
        isHighLighted={isHighLighted}
        isOldPrice={isOldPrice}
        isActive={isActive}
      />
    </StyledCheckoutPriceWrapper>
  );
};
